import WorkOrderEnumMultipleField from '@atom/components/common/workOrderDetail/workOrderFields/WorkOrderEnumMultipleField';
import WorkOrderEnumSingleField from '@atom/components/common/workOrderDetail/workOrderFields/WorkOrderEnumSingleField';
import { DataType } from '@atom/types/dataType';
import { FieldFilter, WorkOrderField } from '@atom/types/work';
import { CustomFieldView } from '@atom/utilities/taskUtilities';

import { createFieldFilterHandlers } from './fieldFilterUtilities';
import WorkOrdersFiltersDatePicker from './WorkOrdersFiltersDatePicker';
import WorkOrdersFiltersNumericRange from './WorkOrdersFiltersNumericRange';

type WorkOrderFieldFilterInputProps = {
  field: WorkOrderField;
  fieldFilter?: FieldFilter;
  onChange: (updatedFilter: FieldFilter) => void;
  disabled?: boolean;
  dataCy?: string;
};

const WorkOrderFieldFilterInput = ({
  field,
  fieldFilter,
  onChange,
  disabled,
  dataCy,
}: WorkOrderFieldFilterInputProps) => {
  const {
    getDateValue,
    handleDateChange,
    handleDateTimeChange,
    handleSelectChange,
    handleNumericChange,
  } = createFieldFilterHandlers(field.id, fieldFilter, onChange);

  const components = {
    [DataType.DATE]: (
      <WorkOrdersFiltersDatePicker
        field={field}
        startDateValue={getDateValue('valueStart')}
        endDateValue={getDateValue('valueEnd')}
        onStartDateChange={handleDateChange('valueStart')}
        onEndDateChange={handleDateChange('valueEnd')}
        disabled={disabled}
        dataCy={dataCy}
      />
    ),
    [DataType.DATE_TIME]: (
      <WorkOrdersFiltersDatePicker
        field={field}
        startDateValue={getDateValue('valueStart')}
        endDateValue={getDateValue('valueEnd')}
        onStartDateChange={handleDateTimeChange('valueStart')}
        onEndDateChange={handleDateTimeChange('valueEnd')}
        disabled={disabled}
        dataCy={dataCy}
      />
    ),
    [DataType.ENUM_SINGLE]: (
      <WorkOrderEnumSingleField
        field={{ ...field, value: fieldFilter?.value }}
        onChange={handleSelectChange('value')}
        isDisabled={disabled}
        customFieldView={CustomFieldView.FILTER}
        dataCy={dataCy}
      />
    ),
    [DataType.ENUM_MULTIPLE]: (
      <WorkOrderEnumMultipleField
        field={{ ...field, value: fieldFilter?.values }}
        onChange={handleSelectChange('values')}
        isDisabled={disabled}
        customFieldView={CustomFieldView.FILTER}
        dataCy={dataCy}
      />
    ),
    [DataType.NUMBER]: (
      <WorkOrdersFiltersNumericRange
        field={field}
        startValue={fieldFilter?.valueStart}
        endValue={fieldFilter?.valueEnd}
        onStartChange={handleNumericChange('valueStart')}
        onEndChange={handleNumericChange('valueEnd')}
        disabled={disabled}
        dataCy={dataCy}
      />
    ),
  };

  return components[field.dataType] || null;
};

export default WorkOrderFieldFilterInput;
